<template>
  <div class="phone-validate">
    <div>
      <step-header :step="step"></step-header>
    </div>
    <div class="mail-active">
      <div class="title-validate">邮箱激活</div>
      <div class="active-info">
        <div class="line1">感谢注册!</div>
        <div class="line2">确认邮件已发送至邮箱：{{email}}</div>
        <div class="line3">请查看邮件，并激活腾讯优图·AI开放平台帐号。</div>
        <div class="receive-mail">
          <div class="title">没有收到邮件？</div>
          <div class="line1">
            <span>1.请检查邮箱地址是否正确，可以返回</span>
            <span class="a-link" @click="jumpToMailValidate">重新填写</span>
          </div>
          <div class="line2">2.检查垃圾邮件</div>
          <div class="line3">
            <span>3.若仍未收到，请尝试</span>
            <span class="a-link" @click="handleSubmitForm">重新发送</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import MessageType from '@/components/common/message-box/MessageType';
import RouteKey from '@/common/RouteKey';
import StepHeader from '../common/StepHeader';
export default {
  name: 'mail',
  components: {
    StepHeader
  },
  data() {
    return {
      email: this.$route.query.email,
      step: 3
    };
  },
  methods: {
    jumpToMailValidate() {
      this.$router.transfer(RouteKey.OPEN_VERIFY_MAIL);
    },
    validateAgreement(rule, value, callback) {
      if (value == null || !value) {
        callback(new Error('请阅读腾讯优图AI开放平台开发者协议'));
      }
      callback();
    },
    handleSubmitForm() {
      let data = {
        email: this.email,
        agree: 'on'
      };
      this.$loader.post(api.user.YTMAIL, data).then((res) => {
        this.$alert('邮件发送成功', null, MessageType.SUCCESS);
      });
    }
  }
};
</script>

<style lang="less">
.phone-validate{
  .title-validate{
    height: 118px;
    line-height: 118px;
    width: 250px;
    margin: 0 auto;
    color: #666666;
    font-size: 24px;
    text-align: center;
    background-image: url(./img/title_element_left.png),  url(./img/title_element_right.png);
    background-repeat: no-repeat;
    background-position: 0px center, right center;
  }
  .mail-active{
    background: #ffffff;
    box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.13);
    .active-info{
      margin-left: 240px;
      font-size: 18px;
      color: #7E858D;
      padding-bottom: 38px;
      .line1{
        font-size: 25px;
        line-height: 36px;
        margin-bottom: 20px;
      }
      .line2, .line3{
        line-height: 30px;
      }
      .receive-mail{
        margin-top: 30px;
        width: 478px;
        height: 140px;
        padding: 16px 36px;
        background: #FFFCF5;
        border: 1px solid #F1DDB1;
        border-radius: 2px;
        .title{
          font-size: 18px;
          line-height: 26px;
          margin-bottom: 6px;
        }
        .line1, .line2, .line3{
          font-size: 14px;
          line-height: 26px;
          margin-bottom: 0;
          .a-link{
            cursor: pointer;
            color: #5c9dff;
            &.a-link{
              color: #3385ff;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/validate/panels/MailActive.vue